/**
 * @fileoverview Configurações → Equipe e permissões (fase 7 do RBAC): as abas
 * Pessoas, Perfis de acesso e Histórico, e o painel de uma pessoa (?user=<id>
 * no endereço, que o "Personalizar permissões" do cadastro abre). A seção só
 * aparece com a regra nova ligada e team.manage_access (registry.js); o
 * servidor confere de novo cada leitura e gravação. A busca, os filtros e a
 * página da aba Pessoas ficam aqui: voltar do painel da pessoa mantém onde estava.
 */

import React, { useState } from "react";
import { useHistory, useLocation } from "react-router-dom";

import api from "../../services/api";
import { i18n } from "../../translate/i18n";
import { LoadError, LoadingState } from "../Settings/LoadState";
import HistoryTab from "./HistoryTab";
import PeopleTab, { INITIAL_PEOPLE_QUERY } from "./PeopleTab";
import PersonPanel from "./PersonPanel";
import RolesTab from "./RolesTab";
import useTeamAccessStyles from "./styles";
import useRequest from "./useRequest";

const TABS = ["people", "roles", "history"];

const TeamAccess = ({ onDirtyChange }) => {
  const classes = useTeamAccessStyles();
  const history = useHistory();
  const location = useLocation();
  const personId = Number(new URLSearchParams(location.search).get("user")) || null;
  const [tab, setTab] = useState("people");
  const [peopleQuery, setPeopleQuery] = useState(INITIAL_PEOPLE_QUERY);
  const catalog = useRequest(() => api.get("/access-control/catalog").then(({ data }) => data), []);

  const openPerson = (id) => history.push({ pathname: location.pathname, search: `?user=${id}` });
  const closePerson = () => history.push({ pathname: location.pathname, search: "" });

  if (catalog.status === "loading") return <LoadingState />;
  if (catalog.status === "error") return <LoadError onRetry={catalog.reload} />;

  if (personId) {
    return (
      <PersonPanel
        key={personId}
        userId={personId}
        catalog={catalog.data}
        onBack={closePerson}
        onDirtyChange={onDirtyChange}
      />
    );
  }

  return (
    <div className={classes.root}>
      <div className={classes.tabs} role="tablist" aria-label={i18n.t("accessControl.tabsLabel")}>
        {TABS.map((id) => (
          <button
            key={id}
            type="button"
            role="tab"
            id={`team-access-tab-${id}`}
            aria-selected={tab === id}
            aria-controls="team-access-tabpanel"
            className={[classes.tab, tab === id ? classes.tabActive : ""].filter(Boolean).join(" ")}
            onClick={() => setTab(id)}
          >
            {i18n.t(`accessControl.tabs.${id}`)}
          </button>
        ))}
      </div>
      <div role="tabpanel" id="team-access-tabpanel" aria-labelledby={`team-access-tab-${tab}`}>
        {tab === "people" && (
          <PeopleTab roles={catalog.data.roles} query={peopleQuery} onQueryChange={setPeopleQuery} onOpen={openPerson} />
        )}
        {tab === "roles" && <RolesTab catalog={catalog.data} />}
        {tab === "history" && <HistoryTab />}
      </div>
    </div>
  );
};

export default TeamAccess;
